/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_03_AltInputs */

const en_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstract fluid artwork`)
};

const ar_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمل فني تجريدي سائل`)
};

const bn_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাবস্ট্রাক্ট ফ্লুইড আর্টওয়ার্ক`)
};

const de_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrakte fließende Kunst`)
};

const es_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obra de arte fluida y abstracta`)
};

const fr_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art fluide abstrait`)
};

const pt_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte fluida abstrata`)
};

const zh_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽象流体艺术品`)
};

const tr_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyut akıcı sanat eserleri`)
};

const ru_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абстрактное плавное произведение искусства`)
};

const pl_elastic_gallery_item_03_alt = /** @type {(inputs: Elastic_Gallery_Item_03_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrakcyjna płynna grafika`)
};

/**
* | output |
* | --- |
* | "Abstract fluid artwork" |
*
* @param {Elastic_Gallery_Item_03_AltInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_03_alt = /** @type {((inputs?: Elastic_Gallery_Item_03_AltInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_03_AltInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_03_alt(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_03_alt(inputs)
	if (locale === "de") return de_elastic_gallery_item_03_alt(inputs)
	if (locale === "es") return es_elastic_gallery_item_03_alt(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_03_alt(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_03_alt(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_03_alt(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_03_alt(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_03_alt(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_03_alt(inputs)
	return en_elastic_gallery_item_03_alt(inputs)
});